import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import type { ViewType } from 'owa-calendar-actions';
import type { ItemPeekViewState } from '../store/schema/ItemPeekState';

export let openItemPeek = action('openItemPeek', (item: CalendarEvent) =>
    addDatapointConfig(
        {
            name: 'OpenItemPeek',
            options: { isCore: true },
        },
        {
            item,
        }
    )
);

export let openItemPeekToRespond = action(
    'openItemPeekToRespond',
    (
        calendarEvent: CalendarEvent,
        eventScope: EventScope,
        responseType: ResponseTypeType,
        titleText: string,
        actionSource: ViewType
    ) =>
        addDatapointConfig(
            {
                name: 'OpenItemPeekToRespond',
            },
            {
                calendarEvent,
                eventScope,
                responseType,
                titleText,
                actionSource,
            }
        )
);

export let openItemPeekToCancel = action(
    'openItemPeekToCancel',
    (item: CalendarEvent, eventScope: EventScope, actionSource: ViewType, titleText: string) =>
        addDatapointConfig(
            {
                name: 'OpenItemPeekToCancel',
            },
            {
                item,
                eventScope,
                actionSource,
                titleText,
            }
        )
);

export let setPeekState = action('setPeekState', (state: ItemPeekViewState) => ({
    state,
}));
